const foods = [
  {
    name: "Paneer",
    proteinContent: 0.14,
    selected: true,
    totalProtein: 0,
    id: (Math.random().toString(36) + "00000000000000000").slice(2, 7),
  },
  {
    name: "Egg",
    proteinContent: 13,
    selected: false,
    totalProtein: 0,
    id: (Math.random().toString(36) + "00000000000000000").slice(2, 7),
  },
  {
    name: "Soyabeans",
    proteinContent: 0.12,
    selected: false,
    totalProtein: 0,
    id: (Math.random().toString(36) + "00000000000000000").slice(2, 7),
  },
  {
    name: "Oats",
    proteinContent: 0.16,
    selected: false,
    totalProtein: 0,
    id: (Math.random().toString(36) + "00000000000000000").slice(2, 7),
  },
  {
    name: "Milk",
    proteinContent: 32,
    selected: true,
    totalProtein: 0,
    id: (Math.random().toString(36) + "00000000000000000").slice(2, 7),
  },
  {
    name: "Rajmah",
    proteinContent: 0.09,
    selected: false,
    totalProtein: 0,
    id: (Math.random().toString(36) + "00000000000000000").slice(2, 7),
  },
  {
    name: "Chicken",
    proteinContent: 0.27,
    selected: false,
    totalProtein: 0,
    id: (Math.random().toString(36) + "00000000000000000").slice(2, 7),
  },
  {
    name: "Chickpeas",
    proteinContent: 0.19,
    selected: false,
    totalProtein: 0,
    id: (Math.random().toString(36) + "00000000000000000").slice(2, 7),
  },
];
export default foods;
